import React from 'react'
import {useForm} from "react-hook-form";

const GenerateGroupName = ({ nextStep, handleChange, values }) => {

    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    const {
        register,
        formState: { errors }
    } = useForm();

    const styles = {
        container: {
            width: "80%",
            margin: "0 auto",
        },
        input: {
            width: "100%",
        },
    };

    return (
        <div className="row">
            <div className="col-md-12">
            <h5 className="tbsub-title mt-3 mb-3">Step 3 of 4</h5>
            <form>
                <div className="col-md-12">
                    <div className="form-group row">
                        <label className="control-label col-md-4">Please, select the group: </label>
                        <input type="text" {...register("salary", { required: true, maxLength: 200 })}
                               style={{ ...styles.input, borderColor: errors.salary && "red",marginRight:"50px" }} onChange={handleChange('salary')}
                               className="form-control form-control-sm col-md-3" />
                    </div>
                </div>
                <button onClick={ Continue }
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="btn btn-primary"
                >Finish Setup</button>
            </form>
            </div>
        </div>
    )
}

export default GenerateGroupName